<template>
  <div>
    <div>
      <!-- AppLayout.vue:247 Muss zwei div's haben sonst werden Charts weggedrückt von <p> -->
      <p v-if="smAndDown" class="mt-2 mb-0 body-1 font-weight-medium text-center">{{ dateLabel }}</p>
      <telemetrie-graph-grid></telemetrie-graph-grid>
    </div>
  </div>
</template>

<script>
import TelemetrieGraphGrid from '@/modules/telemetrie/components/TelemetrieGraphGrid.vue';
import common from '@/mixins/common';
import dateUtils from '@/common/dateUtils';

export default {
  name: 'Telemetrie',
  mixins: [common],
  components: {
    TelemetrieGraphGrid,
  },
  computed: {
    dateLabel() {
      const routeDateFrom = this.$route.params.from;
      const routeDateTo = this.$route.params.to;
      let dateFrom = dateUtils.parseYYYYMMDD(routeDateFrom);
      let dateTo = dateUtils.parseYYYYMMDD(routeDateTo);

      if (routeDateFrom === routeDateTo) {
        return dateUtils.formatAsLocaleNamedShortDateWithYear(dateFrom);
      }

      if (dateFrom.getFullYear() !== dateTo.getFullYear()) {
        dateFrom = dateUtils.formatAsLocaleNamedShortDateWithYear(dateFrom);
        dateTo = dateUtils.formatAsLocaleNamedShortDateWithYear(dateTo);
      } else {
        dateFrom = dateUtils.formatAsLocaleNamedShortDate(dateFrom);
        dateTo = dateUtils.formatAsLocaleNamedShortDate(dateTo);
      }
      return `${dateFrom} - ${dateTo}`;
    },
  },
};
</script>

<style></style>
